import ApiService from "@/core/services/ApiService";
import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { BackendError, Curso, Inscripcion } from "../models";

@Module({ namespaced: true, name: "CursosModule" })
export class CursosModule extends VuexModule {
  errors: BackendError | null = null;
  cursos: Curso[] = [];
  curso: Curso | null = null;
  inscripcion: Inscripcion | null = null;
  //formulario: FamiliaFormulario | null = null;

  @Action
  fetchListado() {
    const url = "/cursos";

    const filter = {
      params: {
        filter: {
          include: [
            {
              relation: "inscripciones",
              scope: { fields: ["id", "estado", "cursoId"] },
            },
          ],
        },
      },
    };

    return ApiService.get(url, filter)
      .then(({ data }) => {
        this.setData(data);
      })
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          if (err.response && err.response.status === 422) {
            this.setError(err.response.data);
          } else if (err.response && err.response.data) {
            this.setError(err.response.data);
          } else {
            const axiosError = { error: err };
            this.setError(axiosError);
          }
        } else {
          const generalError = { error: err };
          this.setError(generalError);
        }
      });
  }

  @Action
  fetchById({ id }: { id: string }) {
    const url = `/cursos/${id}`;
    const filter = {
      params: {
        filter: {
          include: [
            {
              relation: "inscripciones",
              scope: {
                order: ["createdOn DESC"],
              },
            },
          ],
        },
      },
    };

    return ApiService.get(url, filter)
      .then(({ data }) => {
        this.setDetailData(data);
      })
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          if (err.response && err.response.status === 422) {
            this.setError(err.response.data);
          } else if (err.response && err.response.data) {
            this.setError(err.response.data);
          } else {
            const axiosError = { error: err };
            this.setError(axiosError);
          }
        } else {
          const generalError = { error: err };
          this.setError(generalError);
        }
      });
  }
  /*
  @Action
  fetchServiciosColectivosSolicitados(comarcaId?: string) {
    const url =
      comarcaId == null
        ? "/peticion-formularios/servicios-colectivos"
        : `/comarcas/${comarcaId}/peticion-formularios/servicios-colectivos`;

    const filter = {
      params: {
        filter: {
          include: [
            {
              relation: "familia",
              scope: {
                fields: [
                  "id",
                  "dni",
                  "nombre",
                  "apellidos",
                  "email",
                  "telefono",
                  "localidad",
                  "conIngresos",
                  "ingresos",
                  "familiaPrioritaria",
                ],
              },
            },
            {
              relation: "servicioProgramado",
              scope: {
                fields: ["id", "nombre"],
                include: [
                  {
                    relation: "servicio",
                    scope: {
                      fields: [
                        "id",
                        "lugarEspacioColectivo",
                        "lugarPrestacion",
                        "otrosEspacioColectivo",
                        "servicioProgramadoId",
                      ],
                    },
                  },
                ],
              },
            },
            {
              relation: "peticionFormulario",
              scope: {
                fields: ["id", "datosSolicitud"],
              },
            },
          ],
          where: { servicioProgramadoId: { neq: null } },
          order: ["createdOn DESC"],
        },
      },
    };

    if (comarcaId == null) {
      filter.params.filter.include.push({
        relation: "comarca",
        scope: { fields: ["id", "nombre"] },
      });
    }

    return ApiService.get(url, filter)
      .then(({ data }) => {
        const dataSorted = data.sort((a, b) => {
          const aNegativo = [
            FormularioEstado.noApto,
            FormularioEstado.rechazado,
            FormularioEstado.realizadorPorError,
          ].includes(a.estado);
          const bNegativo = [
            FormularioEstado.noApto,
            FormularioEstado.rechazado,
            FormularioEstado.realizadorPorError,
          ].includes(b.estado);

          if (aNegativo && bNegativo) {
            return a.createdOn - b.createdOn;
          } else if (aNegativo || bNegativo) {
            return aNegativo ? 1 : -1;
          }

          return a.createdOn - b.createdOn;
        });
        this.setDataColectivos(dataSorted);
      })
      .catch((err: Error | AxiosError) => {
        console.log(err);
        if (axios.isAxiosError(err)) {
          if (err.response && err.response.status === 422) {
            this.setError(err.response.data);
          } else if (err.response && err.response.data) {
            this.setError(err.response.data);
          } else {
            const axiosError = { error: err };
            this.setError(axiosError);
          }
        } else {
          const generalError = { error: err };
          this.setError(generalError);
        }
      });
  }
*/
  @Action
  fetchCursoInscripcionDetalle({ id }: { id: string }) {
    const url = `/inscripciones/${id}`;

    const filter = {
      params: {
        filter: {
          include: [
            {
              relation: "curso",
              scope: {
                fields: [
                  "id",
                  "nombre",
                  "presencial",
                  "videoconferencia",
                  "areaTematica",
                ],
              },
            },
          ],
        },
      },
    };

    return ApiService.get(url, filter)
      .then(({ data }) => {
        this.setInscripcionData(data);
      })
      .catch((err: Error | AxiosError) => {
        console.log(err);
        if (axios.isAxiosError(err)) {
          if (err.response && err.response.status === 422) {
            this.setError(err.response.data);
          } else if (err.response && err.response.data) {
            this.setError(err.response.data);
          } else {
            const axiosError = { error: err };
            this.setError(axiosError);
          }
        } else {
          const generalError = { error: err };
          this.setError(generalError);
        }
      });
  }

  @Action
  crear({ curso }: { curso }) {
    const url = "/cursos";

    return ApiService.post(url, curso).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        if (err.response && err.response.status === 422) {
          this.setError(err.response.data);
        } else if (err.response && err.response.data) {
          this.setError(err.response.data);
        } else {
          const axiosError = { error: err };
          this.setError(axiosError);
        }
      } else {
        const generalError = { error: err };
        this.setError(generalError);
      }
    });
  }

  @Action
  update({ id, curso }: { id: string; curso }) {
    const url = `/cursos/${id}`;

    return ApiService.put(url, curso).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        if (err.response && err.response.status === 422) {
          this.setError(err.response.data);
        } else if (err.response && err.response.data) {
          this.setError(err.response.data);
        } else {
          const axiosError = { error: err };
          this.setError(axiosError);
        }
      } else {
        const generalError = { error: err };
        this.setError(generalError);
      }
    });
  }
  /*
  @Action
  updateEstadoInscripcion({ id, estado }: { id: string; estado }) {
    const url = `/inscripciones/${id}`;

    return ApiService.put(url, estado).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        if (err.response && err.response.status === 422) {
          this.setError(err.response.data);
        } else if (err.response && err.response.data) {
          this.setError(err.response.data);
        } else {
          const axiosError = { error: err };
          this.setError(axiosError);
        }
      } else {
        const generalError = { error: err };
        this.setError(generalError);
      }
    });
  }
*/
  @Action({ rawError: true })
  updateInscripcion({ id, inscripcion }: { id: string; inscripcion }) {
    const url = `/inscripciones/${id}`;

    return ApiService.put(url, inscripcion).catch(ApiService.handleError);
  }
  /*
  @Action
  aprobarSolicitud({
    comarcaId,
    id,
    peticionFormularioId,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
  }) {
    return this.cambiarEstadoSolicitud({
      comarcaId,
      id,
      peticionFormularioId,
      estado: FormularioEstado.incorporado,
    });
  }
  @Action({ rawError: true })
  rechazarSolicitud({
    comarcaId,
    id,
    peticionFormularioId,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
  }) {
    return this.cambiarEstadoSolicitud({
      comarcaId,
      id,
      peticionFormularioId,
      estado: FormularioEstado.rechazado,
    });
  }
  @Action({ rawError: true })
  realizadoPorErrorSolicitud({
    comarcaId,
    id,
    peticionFormularioId,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
  }) {
    return this.cambiarEstadoSolicitud({
      comarcaId,
      id,
      peticionFormularioId,
      estado: FormularioEstado.realizadorPorError,
    });
  }
  @Action({ rawError: true })
  pendiente({
    comarcaId,
    id,
    peticionFormularioId,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
  }) {
    return this.cambiarEstadoSolicitud({
      comarcaId,
      id,
      peticionFormularioId,
      estado: FormularioEstado.pendiente,
    });
  }
  @Action({ rawError: true })
  listaDeEspera({
    comarcaId,
    id,
    peticionFormularioId,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
  }) {
    return this.cambiarEstadoSolicitud({
      comarcaId,
      id,
      peticionFormularioId,
      estado: FormularioEstado.listaDeEspera,
    });
  }
  @Action
  cambiarEstadoSolicitud({
    comarcaId,
    id,
    peticionFormularioId,
    estado,
  }: {
    comarcaId: string;
    id: string;
    peticionFormularioId: string;
    estado: FormularioEstado;
  }) {
    let endpoint = "";
    switch (estado) {
      case FormularioEstado.pendiente:
        endpoint = "pendiente";
        break;
      case FormularioEstado.realizadorPorError:
        endpoint = "realizadoPorError";
        break;
      case FormularioEstado.rechazado:
        endpoint = "rechazar";
        break;
      case FormularioEstado.incorporado:
        endpoint = "aprobar";
        break;
      case FormularioEstado.listaDeEspera:
        endpoint = "listaDeEspera";
    }
    if (!endpoint) throw new Error("No se ha definido el endpoint");

    const url = `/comarcas/${comarcaId}/servicios-programados/${id}/${endpoint}`;

    this.setError(null);
    return ApiService.post(url, {
      peticionFormularioId: peticionFormularioId,
    })
      .then(() => {
        const peticion = this.servicio?.peticionFormularios?.find(
          (ele) => ele.id === peticionFormularioId
        );

        if (peticion) {
          peticion.estado = estado;
        }
      })
      .catch(ApiService.handleError);
  }

  @Action({ rawError: true })
  reasignarServicioColectivo({
    comarcaId,
    idPeticionFormulario,
    idServicioColectivo,
  }: {
    comarcaId: string;
    idPeticionFormulario: string;
    idServicioColectivo: string;
  }) {
    const url = `/comarcas/${comarcaId}/peticion-formularios/servicio-programado/${idPeticionFormulario}/reasignar`;

    return ApiService.post(url, {
      servicioProgramadoId: idServicioColectivo,
    }).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        if (err.response && err.response.status === 422) {
          throw err.response.data;
        } else if (err.response && err.response.data) {
          throw err.response.data;
        } else {
          const axiosError = { error: err };
          throw axiosError;
        }
      } else {
        const generalError = { error: err };
        throw generalError;
      }
    });
  }
*/
  @Action({ rawError: true })
  enviarDiplomaTodos({ cursoId }: { cursoId: string }) {
    const url = `/cursos/${cursoId}/enviar-diplomas`;

    return ApiService.post(url, {}).catch(ApiService.handleError);
  }

  @Action({ rawError: true })
  enviarDiploma({ cursoId, id }: { cursoId: string; id: string }) {
    const url = `/cursos/${cursoId}/inscripciones/${id}/enviar-diploma`;

    return ApiService.post(url, { id }).catch(ApiService.handleError);
  }

  @Action({ rawError: true })
  descargarDiplomaTodos({ cursoId }: { cursoId: string }) {
    const url = `/cursos/${cursoId}/descargar-diplomas`;

    return ApiService.get(url, {
      responseType: "blob",
    }).catch(ApiService.handleError);
  }

  @Action({ rawError: true })
  descargarDiploma({ cursoId, id }: { cursoId: string; id: string }) {
    const url = `/cursos/${cursoId}/inscripciones/${id}/descargar-diploma`;

    return ApiService.get(url, {
      responseType: "blob",
    }).catch(ApiService.handleError);
  }

  @Action({ rawError: true })
  eliminar({ elementId }: { elementId: string }) {
    const url = `/cursos/${elementId}`;

    return ApiService.delete(url).catch(ApiService.handleError);
  }

  @Mutation
  setError(error) {
    this.errors = error;
  }

  @Mutation
  setData(data) {
    this.cursos = data;
  }
  /*
  @Mutation
  setDataColectivos(data) {
    this.serviciosColectivos = data;
  }
*/
  @Mutation
  setDetailData(data) {
    this.curso = data;
  }
  @Mutation
  setInscripcionData(data) {
    this.inscripcion = data;
  }
  /*
  @Mutation
  setFormularioData(data) {
    this.formulario = data;
  }*/
}
